import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ServiceComponent from "./ServiceComponent";
import logo from "../assets/smiley.png"; // Cambia esta ruta por tu logo
import "../styles/Services.scss";

gsap.registerPlugin(ScrollTrigger);


const Services = () => {
  const [isTwoColumns, setIsTwoColumns] = useState(window.innerWidth < 768);
  const sectionRef = useRef(null); // Referencia para la sección completa
  const titleRef = useRef(null); // Referencia específica para el título
  const logoRef = useRef(null); // Referencia para el logo

  useEffect(() => {
    const handleResize = () => {
      // Cambiar isTwoColumns según el tamaño del viewport
      setIsTwoColumns(window.innerWidth < 768);
    };
   

    // Escuchar cambios de tamaño del viewport
    window.addEventListener('resize', handleResize);

    // Limpieza del event listener al desmontar
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Timeline para el logo y el título
    const titleTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current, // Dispara la animación cuando la sección entra en pantalla
        start: "top 80%", // Comienza cuando el top de la sección está al 80% del viewport
        toggleActions: "play none none none",
      },
    });

    // Movimiento del logo
    titleTimeline.fromTo(
      logoRef.current,
      { x: "-100%" }, // Comienza fuera de pantalla por la izquierda
      { x: "320%", duration: 1.5, ease: "power3.inOut" } // Se mueve a la derecha
    );

    // Revelar el título
    titleTimeline.fromTo(
      titleRef.current,
      { opacity: 0, y: 50 }, // Inicialmente invisible y desplazado hacia abajo
      { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
      "-=1" // Inicia antes de que el logo termine su animación
    );

    // Animación de los servicios
    const serviceElements = sectionRef.current.querySelectorAll(".service-component");
    gsap.fromTo(
      serviceElements,
      { opacity: 0, y: 50 }, // Estado inicial
      {
        opacity: 1,
        y: 0, // Estado final
        duration: 1,
        stagger: 0.3, // Animación escalonada
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current, // Dispara la animación cuando la sección entra en pantalla
          start: "top 80%",
          toggleActions: "play none none none",
        },
      }
    );
  }, []);

  return (
    <section className="services" ref={sectionRef}>
      <div className="logo-reveal-container">
        <img ref={logoRef} src={logo} alt="Logo" className="logo" />
        <h2 ref={titleRef} className="title">
          WHAT WE DO
        </h2>
      </div>

      <ServiceComponent
        service="Art"
        number={1}
        subservices={(isTwoColumns)?["Prints","|", "Personalized design"]:["Prints","Personalized design"]}
        isTwoColumns={true}
        className="service-component"
      />

      <ServiceComponent
        service="Branding"
        number={2}
        subservices={["Art direction & Identity"]}
        isTwoColumns={isTwoColumns}
        className="service-component"
      />

      <ServiceComponent
        service="Illustrations"
        number={3}
        subservices={["Textil & Branding"]}
        isTwoColumns={false}
        className="service-component"
      />

      <ServiceComponent
        service="PRODUCT DESIGN"
        number={4}
        subservices={(isTwoColumns)?["Web design","|", "Ux / Ui design"]:["Web design", "Ux / Ui design"]}
        isTwoColumns={true}
        className="service-component"
      />

      <ServiceComponent
        service="Social Media"
        number={5}
        subservices={(isTwoColumns)?["Content design","|", "Media Strategy"]:["Content design","Media Strategy"]}
        isTwoColumns={true}
        className="service-component"
      />
    </section>
  );
};

export default Services;
